import { render, staticRenderFns } from "./TouchScroll.vue?vue&type=template&id=279087c0&"
import script from "./TouchScroll.vue?vue&type=script&lang=ts&"
export * from "./TouchScroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports